module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAAP///wAAACH5BAAAAAAALAAAAAAMAAwAAAITjI+pB+3fVoIUSFThZdlt03lfAQA7"